import { getDefaultLang } from "@cervval.js/common/src/i18n/languages";

const _fr = {
    bookNow: "Prendre Rendez-vous",
    bookingText: "Choisissez la date de rendez-vous",
    html: {
        productNameTitle: "Motif:",
        productDurationTitle: "Durée",
        productPriceTitle: "Prix"
    }
};

export type _I18nBookingPage = typeof _fr;

const _en: _I18nBookingPage = {
    bookNow: "Take Appointment",
    bookingText: "Choose your appointment date",
    html: {
        productNameTitle: "Reason:",
        productDurationTitle: "Duration",
        productPriceTitle: "Price"
    }
};

/**
 * Return value in required language
 * @param lang Chosen lang
 * @returns 
 */
export function I18nBookingPage(lang?: string): _I18nBookingPage {
    lang = lang ?? getDefaultLang();
    switch (lang) {
        case "en":
            return _en;
        case "fr":
        default:
            return _fr;
    }
}